/* import __COLOCATED_TEMPLATE__ from './admin-blaster-result-item.hbs'; */
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import {
  FREELANCER_SEARCH_RESULT__FAILED_FILTER_NAMES
} from "../../../models/freelancer-search-result";
import { stopClickEvent } from "../../../utils/events";

/**
 * This is the individual admin blaster result
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'tr',
  classNames: ['SH-c-admin-blaster-result-item'],

  /**
   * Register services
   */
  errorTracker: service('error-tracker'),
  state: service('states/routes/admin/blaster'),
  stateManager: service('state-managers/routes/admin/blaster'),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /**
   * The result to display information for.
   *
   * @type {FreelancerSearchResult|null}
   */
  freelancerSearchResult: null,

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {Boolean}    True when the form elements should be disabled
   */
  _areFormElementsDisabled: readOnly('state.areFormElementsDisabled'),

  /**
   * @type {String}     Get the textual representation of the distance.
   */
  _distanceText: computed('freelancerSearchResult.homeDistance', function() {
    let homeDistance = this.get('freelancerSearchResult.homeDistance');
    if (homeDistance < 1) {
      return 'N/A';
    }

    return homeDistance.toFixed(2);
  }),

  /**
   * @type {String}     Get the textual representation of the failed filters.
   */
  _failedFiltersText: computed('freelancerSearchResult.failedSearchFilters', function() {
    return this.get('freelancerSearchResult.failedSearchFilters').reduce((carry, failedFilter) => {
      return carry ? `${carry}, ${failedFilter.get('name')}` : failedFilter.get('name');
    }, '');
  }),

  /**
   * @type {Boolean}    True if this result is checked.
   */
  _isChecked: computed('state.updatedSelectedBlastResultIds.length', function() {
    let updatedSelectedBlastResultsMap = this.get('state.updatedSelectedBlastResultsMap');
    return updatedSelectedBlastResultsMap[this.get('freelancerSearchResult.id')];
  }),

  /**
   * @type {Boolean}     True if this has failed due to a filter
   */
  _isFailedWithFilter: computed('freelancerSearchResult.failedSearchFilters', function() {
    return this.get('freelancerSearchResult.failedSearchFilters.length');
  }),

  /**
   * @type {String}     Get the rate diff as a textual representation.
   */
  _rateDiffText: computed('freelancerSearchResult.failedSearchFilters', function() {
    return this.get('freelancerSearchResult.failedSearchFilters').reduce((carry, failedFilter) => {
      if (failedFilter.get('name') === FREELANCER_SEARCH_RESULT__FAILED_FILTER_NAMES.RATE) {
        return carry ? `${carry} -- ${failedFilter.get('reason')}` : failedFilter.get('reason');
      }

      return carry;
    }, '');
  }),

  actions: {
    /**
     * When the user clicks the checkbox to toggle if this item is selected or not.
     */
    onSearchResultItemCheckboxClicked: function() {
      this.get('stateManager').updateSelectBlastResultToggled(!this.get('_isChecked'), this.get('freelancerSearchResult.id'));
    }
  }
});
